import tonStyles from './../ton.json'

export default {
  color: tonStyles.colors.PrimaryBlack,
  lineColor: tonStyles.colors.SecondaryGrey,
  fontFamily: 'SackersGothicStd, sans-serif',
  fontWeight: '1000',
  fontSize: '12px'
}
